import { dropdownRecipe } from "./dropdown";

export const paperRecipe = {
  intents: {
    filterDropdownPanel: dropdownRecipe.variants.filterDropdown.panel,
    onboardingCard: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius * 4,
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: theme.palette.layout.cardShadow,
      // cardPadding is in spacing units ({ xs, sm }); raw values would land as px.
      padding: theme.spacing(theme.palette.layout.cardPadding.xs),
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(theme.palette.layout.cardPadding.sm),
      },
    }),
    // Same frame as the success dialog paper (RewampDialogShell size="success").
    successCard: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius * 4,
      border: `1.5px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.palette.layout.cardShadow,
      padding: theme.spacing(4),
      overflow: "hidden",
    }),
    emptyStatePanel: ({ theme }) => ({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(1.5),
      padding: theme.spacing(2),
      textAlign: "center",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius * 4,
      borderBottomLeftRadius: theme.shape.borderRadius * 4,
      borderBottomRightRadius: theme.shape.borderRadius * 4,
      boxShadow: theme.palette.layout.dropdownShadow,
    }),
    emptyStateCard: ({ theme }) => ({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(2),
      padding: theme.spacing(4),
      textAlign: "center",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius * 4,
      border: `1.5px solid ${theme.palette.divider}`,
      boxShadow: theme.palette.layout.softCardShadow,
    }),
    emptyStateOption: ({ theme }) => ({
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      gap: theme.spacing(1),
      width: "100%",
      padding: theme.spacing(1.5),
      borderRadius: theme.shape.borderRadius * 3,
      backgroundColor: theme.palette.primary.softSurface,
      boxShadow: "none",
    }),
    filterPanelCompact: ({ theme }) => ({
      padding: theme.spacing(1),
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius * 3,
      boxShadow: "none",
    }),
    filterPanelComfortable: ({ theme }) => ({
      padding: theme.spacing(2),
      backgroundColor: theme.palette.neutral.surface,
      border: `1px solid ${theme.palette.neutral.stroke}`,
      borderRadius: theme.shape.borderRadius * 3,
      boxShadow: "none",
    }),
    actionRowSpread: ({ theme }) => ({
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexShrink: 0,
      gap: theme.spacing(2),
      marginTop: theme.spacing(3),
      backgroundColor: "transparent",
      boxShadow: "none",
    }),
    actionRowEnd: ({ theme }) => ({
      display: "flex",
      justifyContent: "flex-end", // Fallback for xs stretch if needed, but flex-end works
      alignItems: "center",
      flexShrink: 0,
      gap: theme.spacing(2),
      paddingTop: theme.spacing(2),
      backgroundColor: "transparent",
      boxShadow: "none",
      [theme.breakpoints.down("lg")]: {
        justifyContent: "stretch",
      },
    }),
    // Detail-page CTA pair (Guidelines · Apply): right on md+, centred below.
    actionRowCta: ({ theme }) => ({
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      flexWrap: "wrap",
      flexShrink: 0,
      gap: theme.spacing(1.5),
      backgroundColor: "transparent",
      boxShadow: "none",
      [theme.breakpoints.down("md")]: {
        justifyContent: "center",
      },
    }),
    confirmDialogStack: ({ theme }) => ({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(2),
      width: "100%",
      backgroundColor: "transparent",
      boxShadow: "none",
    }),
    confirmDialogText: ({ theme }) => ({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(1),
      width: "100%",
      textAlign: "center",
      backgroundColor: "transparent",
      boxShadow: "none",
    }),
    confirmDialogActions: ({ theme }) => ({
      display: "flex",
      gap: theme.spacing(2),
      width: "100%",
      backgroundColor: "transparent",
      boxShadow: "none",
      "& > *": { flex: 1 },
    }),
    pwaPanel: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius * 3,
      padding: theme.spacing(1.5),
      boxShadow: "none",
    }),
    // Matches a 2-col form grid with a 24px gap, so the field lines up with the left column.
    formHalfColumn: ({ theme }) => ({
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1),
      width: "100%",
      backgroundColor: "transparent",
      boxShadow: "none",
      [theme.breakpoints.up("md")]: {
        width: `calc(50% - ${theme.spacing(1.5)})`,
      },
    }),
  },
};
